export const ORDER_CODES = {
  O003: 'orderNotExist',
  O008: 'orderActionNotApplicable',
};
